import { queryOptions, useQuery } from '@tanstack/react-query';

import type { DTOActiveSubscription } from 'src/apis/dto/DTOSubscription';
import useLogin from 'src/hooks/useLogin';
import { client } from 'src/utils/api';

export const SUBSCRIPTION_QUERY_KEYS = {
  all: ['subscription'] as const,
  active: () => [...SUBSCRIPTION_QUERY_KEYS.all, 'active'] as const,
  pending: (id: string) => [...SUBSCRIPTION_QUERY_KEYS.all, 'pending', id] as const,
  page: () => [...SUBSCRIPTION_QUERY_KEYS.all, 'page'] as const,
};

export const activeSubscriptionsQueryOptions = () =>
  queryOptions({
    queryKey: SUBSCRIPTION_QUERY_KEYS.active(),
    async queryFn() {
      const response = await client.get<DTOActiveSubscription[]>('/api/v1/subscriptions', {
        params: { status: 'ACTIVATED' },
      });
      return response.data;
    },
    staleTime: 1000 * 60 * 5,
  });

export const useActiveSubscriptions = () => {
  const { isLogin } = useLogin();

  return useQuery({
    ...activeSubscriptionsQueryOptions(),
    enabled: isLogin,
  });
};
